import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import { Toaster } from "sonner";
import PageTracker from "@/lib/PageTracker";

// Routes secondaires chargées à la demande — allègent le bundle initial
const LegalNotice = lazy(() => import("@/pages/LegalNotice"));
const Diagnostic  = lazy(() => import("@/pages/Diagnostic"));
const DiagnosticPca = lazy(() => import("@/pages/DiagnosticPca"));
const CV          = lazy(() => import("@/pages/CV"));
const Admin       = lazy(() => import("@/pages/Admin"));
const AuthCallback = lazy(() => import("@/pages/AuthCallback"));

function AppRouter() {
  const location = useLocation();
  // Retour OAuth Google : le session_id arrive en fragment d'URL, traité avant tout routage
  if (location.hash?.includes("session_id=")) {
    return (
      <Suspense fallback={<div className="min-h-screen bg-[#FAF8F5]" />}>
        <AuthCallback />
      </Suspense>
    );
  }
  return (
    <Suspense fallback={<div className="min-h-screen bg-[#FAF8F5]" />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mentions-legales" element={<LegalNotice />} />
        <Route path="/diagnostic" element={<Diagnostic />} />
        <Route path="/diagnostic-pca" element={<DiagnosticPca />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <AppRouter />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="system"
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
